module.exports = __webpack_public_path__ + "static/media/Bronzeportal_tn.955cb920.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/Bronzeportal_tn.jpg
// module id = 756
// module chunks = 0